<template>
  <div class="wrapper">
    <parallax class="page-header header-filter"></parallax>
    <div class="">
      <div class="section text-center t_step">
        <div class="container md-card">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-100 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">Select Visit Date</h2>
              <!-- <md-progress-bar
                class="md-primary"
                md-mode="buffer"
                :md-value="progressNum"
                :md-buffer="progressNum"
              ></md-progress-bar> -->
            </div>
            <md-steppers md-alternative md-linear :md-active-step.sync="active" :md-editable="false">
              <md-step id="first" md-label="First Step - Choose Check In&Out Dates" :md-editable="false" :md-done.sync="first">
              </md-step>
              <md-step id="second" md-label="Second Step - Select Room" :md-editable="false" :md-done.sync="second">
              </md-step>
              <md-step id="third" md-label="Third Step - Finish Information" :md-editable="false" :md-done.sync="third">
              </md-step>
            </md-steppers>
          </div>
        </div>
      </div>
      <div class="section text-center t_content">
        <md-card class="container">
          <div class="md-layout text-left">
            <div class="md-layout-item md-size-100">
              <div class="title">
                <h3>Choose Visit Date</h3>
              </div>
              <!-- <md-datepicker v-model="selectedDate">
                <label>Select date</label>
              </md-datepicker> -->
              <div class='t_dataBox'>
                <HotelDatePicker
                  :startingDateValue="getNightDate(0)"
                  :endingDateValue="getNightDate(1)"
                  :minNights="1"
                  @check-in-changed="checkIn($event)"
                  @check-out-changed="checkOut($event)"
                ></HotelDatePicker>
                <i ref="checkIn" class="t_label checkIn">Check-In</i>
                <i ref="checkOut" class="t_label checkOut">Check-Out</i>
              </div>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label for="adult">Adult</label>
                <md-select v-model="adult" name="adult" id="adult">
                  <md-option value="1">Adult 1</md-option>
                  <md-option value="2">Adult 2</md-option>
                  <md-option value="3">Adult 3</md-option>
                  <md-option value="4">Adult 4</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label for="children">Children</label>
                <md-select v-model="children" name="children" id="children">
                  <md-option value="0">Children 0</md-option>
                  <md-option value="1">Children 1</md-option>
                  <md-option value="2">Children 2</md-option>
                  <md-option value="3">Children 3</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100 text-right">
              <md-button
                href="javascript:void(0)"
                class="md-orange md-lg"
                v-on:click="getter()"
                ><md-icon>send</md-icon>Check Availability
              </md-button>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import HotelDatePicker from 'vue-hotel-datepicker'
  export default {
    prop: {
    },
    components: {
      HotelDatePicker
    },
    data() {
      return {
        active: 'first',
        first: false,
        second: false,
        third: false,
        id: 0,
        progressNum: 33,
        selectedStartDate: '',
        selectedEndDate: '',
        date:'',
        myresult: [],
        selected: {},
        adult: 1,
        children: 0,
        resData: {}
      }
    },
    computed: {

    },
    methods: {
      getData: function () {
        this.resData = this.$route.params
        return this.resData
      },
      checkIn(e) {
        var tempDate = ''
        tempDate = new Date(new Date(e).getFullYear(), new Date(e).getMonth(), new Date(e).getDate())
        this.selectedStartDate = this.formateTime(tempDate, "yyyy-MM-dd")
        return this.selectedStartDate
      },
      checkOut(e) {
        var tempDate = ''
        tempDate = new Date(new Date(e).getFullYear(), new Date(e).getMonth(), new Date(e).getDate())
        this.selectedEndDate = this.formateTime(tempDate, "yyyy-MM-dd")
        return this.selectedEndDate
      },
      getNightDate: function (i) {
        var tempDate = ''
        if (i === 0) {
          tempDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
          this.selectedStartDate = this.formateTime(tempDate, "yyyy-MM-dd")
        } else {
          tempDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+1)
          this.selectedEndDate = this.formateTime(tempDate, "yyyy-MM-dd")
        }
        return tempDate
      },
      formateTime (times, pattern) {
        Date.prototype.Format = function (e) {
          var o = {
            "M+": this.getMonth() + 1,
            "d+": this.getDate(),
            "h+": this.getHours(),
            "m+": this.getMinutes(),
            "s+": this.getSeconds(),
            "q+": Math.floor((this.getMonth() + 3) / 3),
            "S": this.getMilliseconds()
          };
          if (/(y+)/.test(e)) {
            e = e.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
          }
          for (var k in o) {
            if (new RegExp("(" + k + ")").test(e)) {
              e = e.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
            }
          }
          return e
        } 
        var d = new Date(times).Format("yyyy-MM-dd hh:mm:ss")
        if (pattern) {
          d = new Date(times).Format(pattern)
        }
        return d.toLocaleString()
      },
      getter: function (e) {
        sessionStorage.setItem(this.id + "start", this.selectedStartDate);
        sessionStorage.setItem(this.id + "end", this.selectedEndDate);
        sessionStorage.setItem(this.id + "adult", this.adult);
        sessionStorage.setItem(this.id + "children", this.children);
        this.$router.push({name:'showGuestList', params:{
          id: this.id,
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
          adult: this.adult,
          children: this.children
        }})
      }
    },
    created() {
      this.id = 'g' + new Date().getTime().toString() + Math.round(Math.random() * 1000)
    },
    mounted() {
      // axios.get('/api/result').then((res) => {
      //   // console.log(res)
      //   if(res.status === 200) {
      //     this.myresult = res.data.result
      //   } else {
      //     this.myresult = []
      //   }
      //   return this.myresult
      // }).catch((error) => {
      //   console.log(error)
      // })
      
    }
  }
</script>

<style lang="scss" scoped>
  .page-header {
    height: auto;
  }
  .t_main {
    height: 100%;
    position: relative;
  }
  .datepicker__clear-button svg {
    top: 6px !important;
    left: 12px !important;
  }
  .md-ripple > span {
    left: auto;
    width: auto;
  }
  .t_content {
    padding-top: 0px;
    .container {
      margin-top: 0px;
      padding: 20px 20px 60px 20px;
    }
  }
  .t_step{
    padding: 100px 0px 10px; 
    h2{
      padding-top:20px;
    }
  }
</style>
<style lang="scss">
  .md-steppers{
    width: 100%;
    button{
      background-color: #fff!important;
      border: none;
      box-shadow: none;
      &:hover, &:active, &:link{
        background-color: #fff!important;
        border: none;
        box-shadow: none;
        cursor: pointer;
      }
    }
  }
  .md-steppers-navigation{
    box-shadow: none!important;
  }
  .t_dataBox {
    position: relative;
  }
  .t_label {
    position: absolute;
    top: -2px;
    font-style: normal;
    font-size: 11px;
    // font-weight: bold;
    color: rgba(0, 0, 0, 0.54);
    &.checkIn {
      left: 50px;
    }
    &.checkOut {
      left: 50%;
      margin-left: 30px;
    }
  }
</style>